import { device } from "@helpers";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  margin-bottom: 24px;
  & > div {
    margin: 0px 5px;
  }

  & > div:first-child {
    margin-left: 0px;
  }

  & > div:last-child {
    margin-right: 0px;
  }

  @media (min-width: ${device.desktopS}) {
    & > div {
      margin: 0px 10px;
    }
  }
`;

const FormRow = ({ children, ...props }) => (
	<Container {...props}>{children}</Container>
);

export default FormRow;
